<template>
  <Layout :containers="containers">
    <template v-slot:header>
      <DefaultHeroBar
        :hasQuickStartCallout="false"
        :heroTitle="'Terms and conditions'"
        :heroDescription="``"
        :section="'howItWorks'"
      />
    </template>
    <template v-slot:image-text-row-one>
      <Breadcrumb />
      <div class="terms-and-conditions-container mb-16">
        <v-row no-gutters class="mt-4">
          <v-col cols="12">
            <v-row no-gutters>
              <h1>Terms and Conditions</h1>
            </v-row>
            <v-col
              cols="12"
              v-for="section in termsAndConditions"
              :key="section.sectionNumber"
              :id="section.sectionNumber"
              class="terms-section"
              no-gutter
            >
              <h2 class="mt-12 mb-12">
                {{ section.sectionNumber }}&nbsp;&nbsp;&nbsp;{{
                  section.sectionHeader
                }}
              </h2>
              <p class="mt-12 mb-8" v-if="section.subText">
                {{ section.subText }}
              </p>
              <v-row
                class="d-flex justify-start"
                v-for="sectionPoint of section.sectionPoints"
                :key="sectionPoint.id"
              >
                <v-col
                  class="flex-grow-0 point-number"
                  v-if="sectionPoint.id"
                  >{{ sectionPoint.id }}</v-col
                >
                <v-col
                  v-if="!sectionPoint.subSet"
                  v-html="sectionPoint.detail"
                ></v-col>
                <v-col v-else
                  >{{ sectionPoint.detail }}
                  <v-row>&nbsp;</v-row>
                  <v-row
                    class="d-flex justify-start subset-row"
                    v-for="subSet of sectionPoint.subSet"
                    :key="subSet.id"
                  >
                    <v-col class="flex-grow-0 point-number">{{
                      subSet.id
                    }}</v-col>
                    <v-col class="pl-5 ml-1">{{ subSet.detail }}</v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-col>
        </v-row>
      </div>
    </template>
  </Layout>
</template>

<script>
  import Layout from '../common/layouts/Layout.vue';
  import { termsAndConditions } from '../../constants/terms-and-conditions';
  import DefaultHeroBar from '../common/DefaultHeroBar.vue';
  import Breadcrumb from '../common/Breadcrumb.vue';
  export default {
    name: 'OldMutualTermsAndConditions',
    components: {
      Layout,
      DefaultHeroBar,
      Breadcrumb,
    },
    computed: {
      containers() {
        return [
          {
            name: 'header',
            background: 'countryPattern',
            class: 'hero-banner',
          },
          {
            name: 'image-text-row-one',
            accents: ['green-accent-1'],
          },
        ];
      },
    },
    metaInfo() {
      return {
        link: [
          {
            rel: 'canonical',
            href: this.whitelabel.canonicalUrls.termsAndConditions,
          },
        ],
      };
    },
    data() {
      return {
        termsAndConditions: termsAndConditions,
      };
    },
  };
</script>

<style lang="scss">
  .terms-and-conditions-container {
    h1 {
      font-size: 40px;
    }

    h2 {
      font-size: 28px;
    }

    p,
    .terms-section {
      font-size: 24px;

      a {
        font-size: 24px;
      }
    }

    .point-number {
      min-width: 70px;
      max-width: 70px;
    }

    .section-header {
      font-size: 28px;
      font-family: Montserrat, Gill Sans, Gill Sans MT, Calibri, Trebuchet MS,
        sans-serif;
      font-weight: 700;
    }

    .subset-row {
      margin-left: -12px !important;
    }
  }
</style>
